module.exports = {
  api:`//${window.__host__}`,
    //注意！！！！！！！！！！！！！
    //修改image的url请同时修改pages/detail/detail.wxs中的路径
  __index:0,
  image:function(id) {
    let {__current_gallery__ = {}} = window;
    let {useglobal = '0'} = __current_gallery__;
    var prefix = (useglobal && useglobal * 1) ? 'iglobal' : 'image';

    var index = typeof id != 'undefined' ? (id * 1 % 6 + 1) : (++module.exports.__index%6)+1 ;
    return `//${prefix}${index}.jfoto.cn`;
  },
  downloadImage:`//${window.__host__}/api/image/download?url=`,
};



// WEBPACK FOOTER //
// ./src/config.js